enum AlertType {
  WARNING = 'W',
  INFORMATION = 'I',
  CLOSURE = 'C'
}

export default AlertType;
